<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><i>If the muse were mine to tempt it</i></p>
<p class="center"><i>And my feeble voice were strong</i></p>
<p class="center"><i>If my tongue were turned to measures,</i></p>
<p class="center"><i>I would sing a stirring song.</i></p>
<p class="center"><i>I would sing a song heroic</i></p>
<p class="center"><i>Of those noble sons of Ham,</i></p>
<p class="center"><i>Of the gallant colored soldiers</i></p>
<p class="center"><i>Who fought for Uncle Sam!</i></p>
<p class="center1"><i>—Paul Laurence Dunbar,</i> The Colored Soldiers<i>, 1894</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epigraph.vue?35b933fd